import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { CurrentUser, Userprofile } from '../models/user/current-user.model';
import { SchoolmanagementService } from './schoolmanagement.service';
import { UtilService } from './util.service';
import { Observable } from 'rxjs';
import { ComponentheaderService } from './componentheader.service';
import { OfflineDbService } from './offline/offline-db.service';
import { OfflineSessionService } from './offline/offline-session.service';


@Injectable({
  providedIn: 'root'
})
export class UseraccessserviceService {
  passwordupdate(password: string,oldpass:string) {
    let data = {
      "Password": password,
      //"CPassword": cpassword,
      "OldPass":oldpass
    }
    var req_headers = new HttpHeaders({ "content-type": "application/json", "accept": "application/json" });
    return this.http.post(this.rootURL + 'useraccount/passwordupdate',  data, { headers: req_headers });
  }

  readonly rootURL = environment.ImpataAppAPIRoot;
  readonly userTokenLocalStorageKey = environment.userTokenStore;
  readonly tzkey = environment.timezoneapikey;
  //currentUser: CurrentUser;
  //readonly currentUserToken: string;
  private passwordResetSuccessMessage: string;
  public isLoading = false;

  //constructor
  constructor(private http: HttpClient, private router: Router, private schoolmanager: SchoolmanagementService, private util: UtilService, public headerinfo: ComponentheaderService, private offlineDb: OfflineDbService, private offlineSession: OfflineSessionService) {
  }
  /*
   manage the authentication Resposne messages
  */
  setPasswordResetSuccessMessage(msg: string) {
    this.passwordResetSuccessMessage = msg;
  }
  getPasswordResetSuccessMessage() {
    return this.passwordResetSuccessMessage;
  }
  /*
   End section :manage the authentication Resposne messages
  */

  getCurrentUserToken() {
    return localStorage.getItem(this.userTokenLocalStorageKey);
  }

  setAuthenticatedUserToken(token: string) {
    localStorage.setItem(this.userTokenLocalStorageKey, token);
  }

  async logout() {
    // Initiated and awaited before the token is cleared, below — IndexedDB has no
    // synchronous API, so this is the closest available reading of plan §3's "logout
    // wipes everything, synchronously before the token is cleared". Never blocks
    // logout on failure — trapping a user unable to log out is worse than a stale,
    // still-encrypted, still device-bound leftover cache.
    await this.offlineDb.wipeAll().catch((err) => console.error('[offline] wipe on logout failed', err));
    this.offlineSession.reset(); // stale admin/toggle state must not survive into the next session on a shared device

    this.userLogout();

    let logouturl = '/access/login';

    const schoolinfo: any = await this.schoolmanager.getSchoolFromSubdomain();
    if (schoolinfo.logoutURL) {
      logouturl = schoolinfo.logoutURL;
    }
    
    window.location.href = logouturl;
    
  }

  userAuthentitcation(email, password, rootAdmin = false) {
    let data = {
      "emailAddress": email,
      "password": password,
      "isRootAdmin": rootAdmin,
    };

    var req_headers = new HttpHeaders({ "content-type": "application/json", "accept": "application/json" });
    return this.http.post(this.rootURL + 'users/authenticate', data, { headers: req_headers });
  }

  userAuthentication(userid: number, pword: string, rootadmin: boolean) {
    let data = {
      "userid": userid,
      "password": pword,
      "isrootadmin": rootadmin
    };
    var req_headers = new HttpHeaders({ "content-type": "application/json", "accept": "application/json" });
    return this.http.post(this.rootURL + `users/authenticateuserid`, data, { headers: req_headers });
  }

  userLogout() {
    localStorage.removeItem(this.userTokenLocalStorageKey);
  }

  isAlive(): Observable<any> {
    return this.http.get(this.rootURL + 'useraccount/isalive');
  }
  
  loggedIn() {
    const token = this.getCurrentUserToken();
    return token ? true : false;
  }

  async userRegistrationAndSendVerificationMail(name, password, email, countrycode, phone, timezone, timezonename, postVerificationReturnUrl) {
    let user = await this.userRegistration(name, password, email, countrycode, phone, timezone, timezonename, postVerificationReturnUrl).toPromise();
    await this.resendconfirmationemail(email).toPromise();
    return user;
  }
  private userRegistration(name, password, email, countrycode, phone, timezone, timezonename, postVerificationReturnUrl) {

    let data = {
      "Email": email,
      "Password": password,
      "Fullname": name,
      "Phone": phone,
      "CountryCode": countrycode,
      "timezonename": timezonename,
      "timezone": timezone,
      "activated": false,
      "enabled": false,
      "postVerificationReturnUrl": postVerificationReturnUrl
    };

    var req_headers = new HttpHeaders({ "content-type": "application/json", "accept": "application/json" });
    return this.http.post(this.rootURL + 'useraccount/register', data, { headers: req_headers });
  }

  userRegistrationFromInviteMail(payload: string, name, password) {
    let data = {
      "Payload": payload,
      "Name": name,
      "Password": password,
      "TimezoneName": Intl.DateTimeFormat().resolvedOptions().timeZone,
      "Timezone" : new Date().getTimezoneOffset() / 60
    };

    var req_headers = new HttpHeaders({ "content-type": "application/json", "accept": "application/json" });
    return this.http.post(this.rootURL + 'useraccount/registerfrominvitemail', data, { headers: req_headers });
  }
  
  confirmAccount(code) {
    let data = {
      "code": code,
    };

    var req_headers = new HttpHeaders({ "content-type": "application/json", "accept": "application/json" });
    return this.http.post(this.rootURL + 'useraccount/confirmaccount?code=' + code, data, { headers: req_headers });
  }


  forgotPassword(email) {
    let data = {
      "Email": email,
    };

    var req_headers = new HttpHeaders({ "content-type": "application/json", "accept": "application/json" });
    return this.http.post(this.rootURL + 'useraccount/forgotpassword', data, { headers: req_headers });
  }

  forgotPasswordReset(code, password) {
    let data = {
      "Email": "na@impata.com",
      "ResetCode": code,
      "Password": password
    };

    var req_headers = new HttpHeaders({ "content-type": "application/json", "accept": "application/json" });
    return this.http.post(this.rootURL + 'useraccount/forgotpasswordreset', data, { headers: req_headers });
  }

  uploadUserImage(/*schoolid: number, */file: File) {
    let formData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post(this.rootURL + `useraccount/updateuserimage`, formData);
  }

  createuserprofile(userprofile: Userprofile) {
    return this.http.post(this.rootURL + `useraccount/createuserprofile`, userprofile);
  }

  getuserprofile(userid: number): Observable<Userprofile> {
    return this.http.get<Userprofile>(this.rootURL + `useraccount/getuserprofile?userid=${userid}`);
  }

  getuserprofileimage(userid: number): Observable<any> {
    //debugger;
    return this.http.get(this.rootURL + `useraccount/getuserprofileimage?userid=${userid}`);
  }

  // Reads the timezone the browser is actually set to. This used to return a
  // hardcoded { timezone_offset: 1, timezone: 'Africa/Lagos' }, which placed every
  // user without a saved timezone in Lagos regardless of where they were — and the
  // product sells into Nigeria, the US and Canada.
  // Intl gives the exact IANA zone with no network call and no permission prompt,
  // and is already what the registration flows use.
  getClientTimezoneInfo() {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return {
      // getTimezoneOffset() counts minutes *behind* UTC, so it is inverted here to
      // match the hours-ahead convention the profile and registration payloads use
      timezone_offset: -(new Date().getTimezoneOffset() / 60),
      timezone,
      date_time: new Date().toISOString(),
    };
  }

  resendconfirmationemail(email: string): Observable<any> {
    let data = {
      "email": email,
    };
    return this.http.post(this.rootURL + `useraccount/resendverification?email=${email}`, data);
  }

  updateUserFirstTime(val){
    return this.http.post(this.rootURL + `useraccount/setuserfirsttime`, {"isFirstTime" : val});
  }
  
  userGoogleAuthentication(code:string, timezoneinfo: any = null){   
    var timezone = timezoneinfo?.timezone_offset ?? "";
    var timezonename = timezoneinfo?.timezone ?? "";
    let data = { 
      "code": code, 
    };
    if(timezoneinfo !== null){
      data['timezone'] = timezone;
      data['timezonename'] = timezonename;
    }
    var req_headers = new HttpHeaders({ "content-type": "application/json", "accept": "application/json" });
    return this.http.post(this.rootURL + `users/googleauth`, data, { headers: req_headers });
  }

  updateUserPrivateSchool(email: string){
    return this.http.get(this.rootURL + `users/updateprivateschool?email=${email}`);
  }
}
